import "./style.scss";

import { FC, useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import { ReactComponent as IconLogout } from "../../assets/img/icons/icon_logout.svg";
import { ReactComponent as IconUser } from "../../assets/img/icons/icon_User.svg";
import { ReactComponent as IconPremium } from "../../assets/img/icons/icon_premium.svg";
import { UserContext } from "features/account";
import { getSubscription } from "features/account";

type MenuProfileProps = {
    isCollapsed: boolean;
    forBPI?: boolean;
};

const MenuProfile: FC<MenuProfileProps> = ({ isCollapsed , forBPI = false}) => {
    const { user, logoutFonction, logoutFonctionADV, userType, getMe } = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(true);
    const urlType = userType === "partner" ? "/professionnels/" : "/particuliers/";
    const location = useLocation();


    useEffect(() => {
        if (user?.firstname) {
            setIsLoading(false); // Dès que l'utilisateur est chargé, on désactive le loader
        }
        else {
            getMe();
        }
    }, [user]); // Exécution à chaque changement de `user`

    const type = user?.type;

    const [hasOffer, sethasOffer] = useState<any>(null);
    useEffect(() => {
        const checkOffer = async () => {
            try {
                const response = await getSubscription(type, user?.email);
                if (response.data.offrePurchase && response.data.offrePurchase.id > 1) {
                    sethasOffer(true);
                }
                else{
                    sethasOffer(false);
                }

            } catch (error) {
                console.log(error);
            }
        };

        if (user) {
            checkOffer();
        }
    }, [user, type]);


    return (
        <ul className="aside__profile">
            {isLoading ? (
                <li className="loader">Chargement...</li> //
            ) : (
                user?.firstname && user?.lastname && (
                    <li className={location.pathname === `${urlType}profil` ? "active" : ""}>
                        <Link
                            to={`${urlType}profil`}
                            className="aside__button "
                        >
                            {hasOffer && (
                              <div
                                className={`${!isCollapsed ? 'w-2/4' : 'px-1'} py-1 d-flex flex-row align-items-center justify-content-center bg-primary-40 rounded-sm text-sm mb-2`}>
                                  <IconPremium
                                    fill={"#fff"}
                                    width="15px"
                                    height={15}
                                  />
                                  {!isCollapsed && (
                                    <span className={"px-2"}>PREMIUM</span>
                                  )}
                              </div>
                            )}
                            <div className="aside__item align-items-top">
                                <IconUser
                                  fill={"#fff"}
                                  width="24px"
                                  height={40}
                                />
                                {!isCollapsed && (
                                  <div className="aside__item__content">
                                  <span>{user?.firstname + " " + user?.lastname}</span>
                                        <p>{user?.email}</p>
                                    </div>
                                )}
                            </div>
                        </Link>
                    </li>
                )
            )}
            {(userType || user) && (
                <li onClick={forBPI ? logoutFonctionADV : logoutFonction}>
                    <div className="aside__button">
                        <div className="aside__item">
                            <IconLogout
                                fill={"#fff"}
                                width="24px"
                                height={40}
                            />
                            {!isCollapsed && <span>Deconnexion</span>}
                        </div>
                    </div>
                </li>
            )}
        </ul>
    );
};

export default MenuProfile;
